import type { ByKind, DealKind } from '../../../api/projectManagement';
import { eurShort } from '../formatters';

export const DEAL_KIND_LABEL: Record<DealKind, string> = {
  new: 'New business',
  expansion: 'Expansion + upsell',
  renewal: 'Renewal',
  pilot: 'Pilot',
  other: 'Other',
};

/** Attio go-live (Brussels): wins before this were made in Salesforce and are never credited to a rep. */
export const ATTIO_GO_LIVE_ISO = '2026-01-07T23:00:00.000Z';

export function isPreAttioWin(actualCloseDate: string | null | undefined): boolean {
  return !actualCloseDate || actualCloseDate < ATTIO_GO_LIVE_ISO;
}

/** "Expansion + upsell €73k · 1 · Renewal €40k · 2" for the non-headline kinds that have deals. */
export function secondaryKindsLine(byKind: ByKind): string {
  return (['expansion', 'renewal', 'pilot', 'other'] as const)
    .filter((k) => byKind[k].count > 0)
    .map((k) => `${DEAL_KIND_LABEL[k]} ${eurShort(byKind[k].valueEur)} · ${byKind[k].count}`)
    .join(' · ');
}

/** "YYYY-Qn" of today on the Brussels calendar. */
export function currentQuarter(now = new Date()): string {
  const day = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit' }).format(now);
  const [year, month] = day.split('-');
  return `${year}-Q${Math.floor((Number(month) - 1) / 3) + 1}`;
}
